/* ALB · Google Store-Widget (Händlerbewertung) im Footer neben dem REVIEWS.io-Logo.
   Googles merchantwidget.js kennt nur eine schwebende Ecke (position: fixed). Wir starten es
   normal und hängen den Rahmen #google-merchantwidget-iframe-wrapper danach in unseren Platz:
   - Google-Intro (Textbanner ~370–400 px, ca. 2 s): Overlay ab dem Platz, in den Viewport
     geschoben. NICHT verstecken/abschneiden: Google klappt erst zur Pille, wenn das Intro
     sichtbar war (getestet 14.10.2026 – abgeschnitten blieb es dauerhaft im Intro).
   - zugeklappt: Pille sitzt im Platz (bekommt erst jetzt ihre Breite), mittig zum Logo
   - aufgeklappt: Overlay nach oben, horizontal in den Viewport geschoben
   Lädt erst, wenn der Footer in die Nähe kommt UND Marketing-Cookies erlaubt sind
   (das Google-iframe setzt das Cookie NID). */
(function () {
  if (customElements.get('alb-google-widget')) return;

  var SKRIPT = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
  var RAHMEN_ID = 'google-merchantwidget-iframe-wrapper';

  function mitEinwilligung(los) {
    var S = window.Shopify;
    function pruefen() {
      var cp = S && S.customerPrivacy;
      if (cp && cp.marketingAllowed && cp.marketingAllowed()) { los(); return; }
      document.addEventListener('visitorConsentCollected', function (e) {
        if (e.detail && e.detail.marketingAllowed) los();
      });
    }
    if (S && S.customerPrivacy) { pruefen(); return; }
    if (S && S.loadFeatures) {
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { pruefen(); });
      return;
    }
    pruefen();
  }

  class AlbGoogleWidget extends HTMLElement {
    connectedCallback() {
      if (this._gestartet) return;
      this._gestartet = true;
      if (!('IntersectionObserver' in window)) { mitEinwilligung(this.laden.bind(this)); return; }
      var io = new IntersectionObserver(function (eintraege) {
        if (!eintraege.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        mitEinwilligung(this.laden.bind(this));
      }.bind(this), { rootMargin: '600px 0px' });
      io.observe(this);
    }

    laden() {
      if (this._geladen) return;
      this._geladen = true;
      if (window.merchantwidget && window.merchantwidget.start) { this.starten(); return; }
      var s = document.createElement('script');
      s.src = SKRIPT;
      s.async = true;
      s.onload = this.starten.bind(this);
      document.head.appendChild(s);
    }

    starten() {
      if (document.getElementById(RAHMEN_ID)) return;
      // Das Schließen-X sitzt unten links im Rahmen. Desktop: genau auf der Pille.
      // Handy (Googles Grenze 480 px): Detailansicht wird an den linken Rand geschoben, das X
      // läge auf dem REVIEWS.io-Logo → aufgeklappt über die Zeile heben (rechts unten liegt
      // der „Nach oben“-Knopf des Themes, deshalb nicht RIGHT_BOTTOM).
      this.schmal = window.innerWidth <= 480;
      try {
        window.merchantwidget.start({
          merchant_id: Number(this.dataset.merchantId),
          position: 'LEFT_BOTTOM',
          region: this.dataset.region || undefined
        });
      } catch (e) { return; }

      var w = document.getElementById(RAHMEN_ID);
      if (!w) return;
      this.rahmen = w;
      // Einmalig umsetzen; die Lage kommt danach nur noch über Variablen am Platz,
      // damit der Observer unten nicht auf eigene Schreibzugriffe reagiert.
      w.style.setProperty('position', 'absolute', 'important');
      w.style.removeProperty('right');
      w.style.setProperty('left', 'var(--alb-gw-x, 0px)', 'important');
      w.style.setProperty('bottom', 'var(--alb-gw-y, 0px)', 'important');
      w.style.zIndex = '20';
      var f = w.querySelector('iframe');
      if (f) f.title = 'Händlerbewertung von Google';
      this.appendChild(w);

      new MutationObserver(this.abgleichen.bind(this)).observe(w, { attributes: true, attributeFilter: ['style', 'hidden'] });
      this.abgleichen();
    }

    abgleichen() {
      var w = this.rahmen;
      if (w.hidden) { this.style.width = ''; this.classList.remove('is-bereit', 'is-offen'); return; }
      var b = parseFloat(w.style.width) || 0;
      var h = parseFloat(w.style.height) || 0;
      if (!b || !h) return;

      var offen = h > 120;
      // Pille und Intro-Banner mittig zur Zeile; aufgeklappt bleibt die Unterkante der Pille
      // stehen (Desktop) bzw. sitzt knapp über der Zeile (Handy)
      if (!offen) this.style.setProperty('--alb-gw-y', ((this.clientHeight - h) / 2) + 'px');
      else if (this.schmal) this.style.setProperty('--alb-gw-y', (this.clientHeight + 4) + 'px');
      if (!offen && b <= 160) {
        // zugeklappt per CSS verkleinert (--alb-gw-scale, Höhe wie REVIEWS.io-Badge)
        var s = parseFloat(getComputedStyle(this).getPropertyValue('--alb-gw-scale')) || 1;
        this.style.width = Math.round(b * s) + 'px';
        this.classList.add('is-bereit');
      }
      this.classList.toggle('is-offen', offen);
      this.classList.toggle('is-intro', !offen && b > 160);

      // Ragt der Rahmen (Intro oder Detailansicht) aus dem Viewport, nach links schieben.
      // Google macht das iframe höchstens viewport-breit, sichtbar ist also min(b, vw).
      var r = this.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      var sichtbar = Math.min(b, vw);
      var rand = Math.max(0, Math.min(8, (vw - sichtbar) / 2));
      var x = Math.min(0, vw - rand - r.left - sichtbar);
      x = Math.max(x, rand - r.left);
      this.style.setProperty('--alb-gw-x', Math.round(x) + 'px');
    }
  }

  customElements.define('alb-google-widget', AlbGoogleWidget);
})();
